import { Controller } from '@hotwired/stimulus'

// Payment Recordings Controller
//
// Handles checkbox selection and group toggling for dividend payment recording.
//
// Targets:
//   checkbox - Individual dividend checkboxes
//
// Actions:
//   toggleGroup - Toggle all checkboxes in a dividend group
//
export default class extends Controller {
  static targets = ['checkbox']

  connect() {
    this.updateSelectionCount()
  }

  // Toggle all checkboxes in a dividend group
  //
  // When the header checkbox is clicked, check/uncheck all dividends
  // in that group (same table).
  toggleGroup(event) {
    const checked = event.target.checked
    const group = event.target.closest('.dividend-group')

    if (!group) return

    // Find all dividend checkboxes in this group (using Stimulus target attribute)
    const checkboxes = group.querySelectorAll('[data-payment-recordings-target="checkbox"]')

    checkboxes.forEach(cb => {
      cb.checked = checked
    })

    this.updateSelectionCount()
  }

  // Update selection count display
  //
  // Called when checkboxes change. Updates the summary banner
  // to show how many dividends are selected.
  updateSelectionCount() {
    const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length

    // Update summary if it exists
    const summary = document.querySelector('.selection-summary')
    if (summary && checkedCount > 0) {
      const totalCount = this.checkboxTargets.length
      summary.innerHTML = `${checkedCount} of ${totalCount} dividend${totalCount !== 1 ? 's' : ''} selected`
      summary.style.backgroundColor = '#e3f2fd'
      summary.style.borderLeftColor = '#1565c0'
    }
  }

  // Connect checkbox targets and attach change listeners
  checkboxTargetConnected(checkbox) {
    checkbox.addEventListener('change', () => this.updateSelectionCount())
  }
}
